import StyledCard from './styles';

const Card = ({
    children,
    className,
}) => (
    <StyledCard className={className}>
        {children}
    </StyledCard>
);

export default Card;
